// extracted by mini-css-extract-plugin
module.exports = {"svgIcon":"SvgIcon_svgIcon__VnXr7","sizeAuto":"SvgIcon_sizeAuto__MFzua","sizeLarge":"SvgIcon_sizeLarge__gppPD","sizeSmall":"SvgIcon_sizeSmall__xemnu"};